module.exports = __webpack_public_path__ + "img/space-bg.a03836f8.png";